// extracted by mini-css-extract-plugin
export default {"header":"Table_header__Um+3O","link":"Table_link__65ApS","active":"Table_active__jCLNT","inactive":"Table_inactive__53QPc"};